import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { CancelButton, Modal, type ModalProps, ProceedButton } from '@/shared/ui'

export type LogoutDialogProps = ModalProps & {
    onConfirm: () => void
}

export function LogoutDialog({ onConfirm, ...modalProps }: LogoutDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...modalProps}>
            <Modal.CloseButton onClose={modalProps.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'info' })} icon="fa-solid fa-right-from-bracket">
                {i18n.BUTTON_LOGOUT}
            </Modal.Header>
            <Modal.Body>{i18n.TEXT_CONFIRM_LOGOUT}</Modal.Body>
            <Modal.Buttons>
                <CancelButton onPress={modalProps.onClose}>{i18n.BUTTON_TOGAME}</CancelButton>
                <ProceedButton onPress={onConfirm}>{i18n.BUTTON_LOGOUT}</ProceedButton>
            </Modal.Buttons>
        </Modal>
    )
}
